import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from 'firebase/functions';

// Your Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAHGjuPEhNdJilTJudJF6f1GnjoUU24jFA",
  authDomain: "ai-avatar-photobooth.firebaseapp.com",
  databaseURL: "https://ai-avatar-photobooth-default-rtdb.firebaseio.com",
  projectId: "ai-avatar-photobooth",
  storageBucket: "ai-avatar-photobooth.appspot.com",
  messagingSenderId: "511386258101",
  appId: "1:511386258101:web:b4f00d57ef5eb027118cfc",
  measurementId: "G-4478JDRD58",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app);

// Sign in anonymously
const signIn = async () => {
  try {
    const userCredential = await signInAnonymously(auth);
    return userCredential.user.uid;
  } catch (error) {
    console.error("Error signing in anonymously:", error);
  }
};

export { app, auth, db, signIn,functions };
